import React from 'react';
import SMTrackHelper from 'components/helpers/SMTrackHelper';
import SMAppHelper from 'components/helpers/SMAppHelper';
import SMFormatHelper from 'components/helpers/SMFormatHelper';
import sprintf from 'sprintf';
import moment from 'moment';
import SMConst from 'lib/SMConst';
import SMSpaceMapView from 'components/spaces/SMSpaceMapView';
import SMRailsBridge from 'lib/SMRailsBridge.js.erb';

class SMItineraryView extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      mailUrl: "",
      fbUrl: "",
      lineUrl: "",
    };
  }
  
  componentDidMount() {

    const reservation = this.props.reservation;
    const user = reservation.user;
    const room = reservation.room;
    
    // mail
    let url = "http://" + location.host + Routes.itinerary_path(reservation.uid, {
      utm_campaign: campaign,
      utm_source: "email",
      utm_medium: "share",
    });
    const campaign = "itinerary-" + reservation.uid;
    const subject = I18n.t('service.subject_000001');
    const br = "%0d%0a";
    const body = sprintf(I18n.t('service.text_000003') + "%s%s",
      user.contact_name, 
      SMFormatHelper.roomName(room),
      br + br,
      encodeURIComponent(url)
    );
    const mailUrl = sprintf("mailto:?subject=%s&body=%s", subject, body);
    
    // facebook
    const prefix = location.pathname.length && location.pathname[0] == "?" ? "&" : "?";
    url = location.href + sprintf("%sutm_campaign=%s&utm_source=%s&utm_medium=%s",
      prefix, campaign, "facebook", "share"
    );
    const redirect = encodeURIComponent("https://spacemarket.com/");
    const fbUrl = sprintf("http://www.facebook.com/dialog/send?app_id=%s&link=%s&redirect_uri=%s",
      SpaceMarket.Config.FBAppID, encodeURIComponent(url), redirect
    );
     
    // line
    url = location.href + sprintf("%sutm_campaign=%s&utm_source=%s&utm_medium=%s",
      prefix, campaign, "line", "share"
    );
    const lineUrl = sprintf("http://line.me/R/msg/text/?%s",
      encodeURIComponent(subject + " " + url),
    );
    this.setState({
      mailUrl: mailUrl,
      fbUrl: fbUrl,
      lineUrl: lineUrl,
    });
  }
  
  renderCancelPolicy(room) {
    let url = SMAppHelper.policyUrl(room);
    return <p><a href={url} className="link-hover-border">キャンセルポリシー</a></p>;
  }

  renderTerms(room) {
    let url = SMAppHelper.termsUrl(room);
    return <p><a href={url} className="link-hover-border">利用規約</a></p>;
  }
  
  renderAmenities(room, amenityType) {
    let amenities = [];
    let amenityList = [];
    room.amenities.forEach((amenity)=>{
      amenityList.push(amenity.name);
    });
    this.props.amenities.forEach((amenity)=>{
      if (amenityType == SMConst.AmenityType.Rental) {
        if (amenity.amenity_type == SMConst.AmenityType.Stay) return;
      }
      let className = "col-xs-6 col-md-3";
      if (amenityList.indexOf(amenity.name) == -1) {
        className += " is-none";
      }
      amenities.push(
        <li key={amenity.name} className={className}>{amenity.name_text}</li>
      );
    });
    return amenities;
  }
  
  formatStartedAt(reservation) {
      if (reservation.rent_type == SMConst.RentType.Stay) {
        return moment(reservation.stay_checkin_at).utc();
      } else {
        return moment(reservation.started_at).utc();
      }
  }
  
  formatEndedAt(reservation) {
     if (reservation.rent_type == SMConst.RentType.Stay || reservation.is_hourly) {
       return moment(reservation.rent_type == SMConst.RentType.Stay ? reservation.stay_checkout_at : reservation.ended_at).utc();
     } else {
       let m = moment(reservation.rent_type == SMConst.RentType.Stay ? reservation.stay_checkout_at : reservation.ended_at).utc();
       return m.subtract(1, 'days');
     }
  }
  
  render() {
    const reservation = this.props.reservation;
    const room = reservation.room;
    const user = reservation.user; 
    const googleMapUrl = sprintf("https://www.google.com/maps?q=%s,%s+(%s)",
      room.space.latitude,
      room.space.longitude,
      encodeURIComponent(room.space.name_text)
    );
    
    const startedAt = this.formatStartedAt(reservation);
    const endedAt = this.formatEndedAt(reservation);
    
    return (
      <div className="site-main page__itinerary">
        <div className="page__itinerary-inner">
          <div className="itinerary-container">
            <div className="mod-heroimg">
              <img src={SMFormatHelper.roomImageURL(room, {width: 1200, height: 670})} alt={SMFormatHelper.roomNameWithSpace(room)} className="mod-heroimg__img" />
            </div>
            <div className="itinerary-container__inner">
              <h1 className="itinerary__title">
                {/* <img src={user.profile_image} alt={user.name} className="itinerary__subscriber-img" /> */}
                {/* <a href={Routes.user_path(user.username)}>{user.name}</a> さんから<br /> */}
                {SMFormatHelper.roomNameWithSpace(room)} の利用日程
              </h1>
              <p className="itinerary__reserve-id">予約ID：{reservation.id}</p>
              <p className="itinerary__share-title">このページを参加者にシェアしましょう！</p>
              <ul className="row itinerary__social">
                <li className="col-xs-4">
                  <a href={this.state.mailUrl} target="_blank" className=" social-link__mail"><i className="fa fa-envelope"></i></a>
                </li>
                <li className="col-xs-4">
                  <a href={this.state.lineUrl} target="_blank" className="social-link__line"><i className="icon-spm-line"></i></a>
                </li>
                <li className="col-xs-4">
                  <a href={this.state.fbUrl} target="_blank" className="social-link__facebook"><i className="fa fa-facebook-square"></i></a>
                </li>
              </ul>
      
              <div className="row itinerary__date">
                <div className="odd-col__line clearfix">
                  <div className="col-md-5 col-xs-12">
                    <p className="itinerary__date-title">利用開始（チェックイン）</p>
                    <p className="itinerary__date-content">
                      <span className="itinerary__date-detail">{startedAt.format(I18n.t("datetime.label_000003"))} {startedAt.format(I18n.t("datetime.label_000004"))}{I18n.t(sprintf("datetime.wday_%d", startedAt.weekday()))}</span>
                      {(()=> {
                        if (reservation.rent_type == SMConst.RentType.Stay || reservation.is_hourly) {
                          return <span className="itinerary__date-detail">{startedAt.format(I18n.t("datetime.label_000005"))}</span>;
                        }
                      })()}
                    </p>
                  </div>
                  <div className="col-md-2 col-xs-12 ta-c">
                    <span className="itinerary__arrow itinerary__date-to">から</span>
                  </div>
                  <div className="col-md-5 col-xs-12">
                    <p className="itinerary__date-title">利用終了（チェックアウト）</p>
                    <p className="itinerary__date-content">
                      <span className="itinerary__date-detail">{endedAt.format(I18n.t("datetime.label_000003"))} {endedAt.format(I18n.t("datetime.label_000004"))}{I18n.t(sprintf("datetime.wday_%d", endedAt.weekday()))}</span>
                      {(()=> {
                        if (reservation.rent_type == SMConst.RentType.Stay || reservation.is_hourly) {
                          return <span className="itinerary__date-detail">{endedAt.format(I18n.t("datetime.label_000005"))}</span>;
                        }
                      })()}
                    </p>
                  </div>
                </div>
              </div> 

              <div className="itinerary__box">
                <h2 className="itinerary__title2">スペースについて</h2>
                <div className="itinerary__about-box clearfix">
                  <div className="row">
                    <div className="col-md-4 col-xs-12">
                      <img src={SMFormatHelper.spaceImageURL(room.space, {width: 630, height: 420, crop: 'pad', background: '#9c9c9c'})} alt="" className="itinerary__about-img" />
                    </div>
                    <div className="col-md-8 col-xs-12">
                      <h3 className="itinerary__about-name">{SMFormatHelper.spaceName(room.space)}</h3>
                      <p className="itinerary__about-content" dangerouslySetInnerHTML={{__html:SMFormatHelper.description(room.space.description)}} />
                      <p className="itinerary__about-link"><a href={Routes.space_room_path(room.space.username, room.uid)}>会場詳細へ</a></p>
                    </div>
                  </div>
                </div>
                <div className="itilerary-container__about-text row">
                  <h3 className="itinerary__title3 col-md-2 col-xs-12">設備・サービス</h3>
                  <p className="col-md-10 col-xs-12" dangerouslySetInnerHTML={{__html:SMFormatHelper.description(room.description)}} />
                </div>
                <div className="itilerary-container__about-text row">
                  <h3 className="itinerary__title3 col-md-2 col-xs-12">アメニティ</h3>
                  <div className="col-md-10 col-xs-12 space-main__amenity">
                    <ul className="row">
                      {this.renderAmenities(room, SMConst.AmenityType.Rental)}
                    </ul>
                  </div>
                </div>
                {(()=> {
                  if (room.trash_description != null) {
                    return (
                      <div className="itilerary-container__about-text row">
                        <h3 className="itinerary__title3 col-md-2 col-xs-12">後片付け・<br />ゴミについて</h3>
                        <div className="col-md-10 col-xs-12 space-main__amenity">
                          <p dangerouslySetInnerHTML={{__html: SMFormatHelper.description(room.trash_description)}} className="col-md-10 col-xs-12"></p>
                        </div>
                      </div>
                    );
                  }
                })()}
                <div className="itilerary-container__about-text row">
                  <h3 className="itinerary__title3 col-md-2 col-xs-12">注意事項</h3>
                  <div className="col-md-10 col-xs-12">
                    {this.renderCancelPolicy(room)}
                    {this.renderTerms(room)}
                  </div>
                </div>
                <p><a href={Routes.space_room_path(room.space.username, room.uid)} className="button-blue itinerary__button">もっと詳しく見る</a></p>
              </div>

              <div className="itinerary__box">
                <h2 className="itinerary__title2">アクセス</h2>
                <div className="itilerary-container__about-text row">
                  <h3 className="itinerary__title3 col-md-2 col-xs-12">住所</h3>
                  <div className="col-md-10 col-xs-12">
                    <p itemProp="address" itemScope itemType="http://schema.org/PostalAddress"><span itemProp="addressRegion">{room.space.state_text}</span><span itemProp="addressLocality">{room.space.city}</span><span itemProp="streetAddress">{room.space.address_1} {room.space.address_2}</span></p>
                  </div>
                </div>
                <div className="itilerary-container__about-text row">
                  <h3 className="itinerary__title3 col-md-2 col-xs-12">電話番号</h3>
                  <div className="col-md-10 col-xs-12">
                    {room.space.tel}
                  </div>
                </div>
                <div className="itinerary__access-map">
                  <SMSpaceMapView space={room.space} hasInfoWindow={false} />
                </div> 
                <p className="itinerary__access-supple" dangerouslySetInnerHTML={{__html:SMFormatHelper.description(room.space.access)}} />
                <p><a href={googleMapUrl} target="_blank" className="button-blue itinerary__button">Google Mapで開く</a></p>
              </div>

              <div className="itinerary__box">
                <h2 className="itinerary__title2">ホストについて</h2>
                <div className="row">
                  <div className="col-md-2 col-xs-12">
                    <img src={room.owner.profile_image} alt="" className="itinerary__host-img" />
                  </div>
                  <div className="itinerary__host-text col-md-10 col-xs-12">
                    <h3 className="itinerary__host-title">{SMFormatHelper.ownerName(room.owner)}</h3>
                    <p className="itinerary__host-content" dangerouslySetInnerHTML={{__html:SMFormatHelper.description(room.owner.profile)}} />
                  </div>
                </div>
                <p><a href={Routes.owner_path(room.owner.username)} className="button-blue itinerary__button">もっと詳しく見る</a></p>
              </div>

              <div className="itinerary__box">
                <h2 className="itinerary__title2">カスタマーサクセス</h2>
                <p className="itinerary__conact-content">緊急の際にはスペースマーケットヘルプセンターにご連絡ください。</p>
                <p className="itinerary__contact-link"><i className="fa fa-question fa-fw itinerary__contact-link-icon"></i><a target="_blank" href="https://help.spacemarket.com/hc/" className="link-hover-border">ヘルプ</a></p>
                <p className="itinerary__contact-link"><i className="fa fa-envelope fa-fw itinerary__contact-link-icon"></i><a target="_blank" href="https://help.spacemarket.com/hc/ja/requests/new" className="link-hover-border">お問い合わせ</a></p>
              </div>
            </div>
          </div>
          <h2 className="itinerary__title">スペースマーケットとは</h2>
          <p className="ininerary__spm-content">
            SPACEMARKET（スペースマーケット）はレンタルスペースから民泊まで、<br />
          約7,000ものユニークなスペースを簡単に予約できるサービスです。<br />
        イベント開催・経営会議・社員研修などのビジネス利用から、結婚式・誕生会などのパーティー利用まで<br />
            用途に応じて、あなたにぴったりなスペースを見つけることができます。
          </p> 

          <div className="container">
            <div className="row">
              <div className="col-md-6 col-xs-12 itinerary__spm-box">
                <h3 className="itinerary__title3">アプリを使って、<br />いつでも、どこでも簡単に予約を確認。</h3>
                <div className=""></div>
                <img src={SMRailsBridge.assetPath.itineraryApp} alt="アプリを使って、いつでも、どこでも簡単に予約を確認。" className="itinerary__spm-img" />
                <a href="https://itunes.apple.com/jp/app/supesumaketto-hui-yi-shikara/id973447544" className="button-blue itinerary__button">アプリをダウンロード（for iPhone）</a>
              </div>

              <div className="col-md-6 col-xs-12 itinerary__spm-box">
                <h3 className="itinerary__title3">まだアカウントをお持ちでないなら<br />今すぐアカウント登録！</h3>
                <img src={SMRailsBridge.assetPath.itineraryRegist} alt="まだアカウントをお持ちでないなら今すぐアカウント登録！" className="itinerary__spm-img" />
                <a href={Routes.new_user_registration_path()} className="button-blue itinerary__button">アカウント登録</a>
              </div>
            </div>
          </div>
        </div>
      </div>
      
    );
  }

}
export default SMItineraryView;



// WEBPACK FOOTER //
// ./app/javascript/components/itineraries/SMItineraryView.jsx